import mainLogo from '../../images/Caraiga/caraiga_logo_main_small_color.png';
import squareLogo from '../../images/Caraiga/caraiga_vw_audi_logo_square_color.png';
import mainLogoWhite from '../../images/Caraiga/caraiga_vw_audi_logo_square_white.png';
import banner01 from '../../images/Caraiga/caraiga_banner_01.jpg';
import banner03 from '../../images/Caraiga/caraiga_banner_03.jpg';
import banner04 from '../../images/Caraiga/caraiga_banner_04.jpg';
import car123 from '../../images/Caraiga/123_audi.jpg';
import box123 from '../../images/Caraiga/123_caraiga.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Caraiga',
    defaultStoreLink: 'pecascariga.com.br',
    defaultContactEmail: 'ecommerce@caraiga.com.br',
    whatsappNumber: '11 99612 6376',
    CNPJname: 'Caraiga Veiculos LTDA',
    CNPJ: '60.437.944/0001-52',
    CNPJaddress: 'Avenida Ulysses Reis de Mattos 100, Real Parque, São Paulo SP - 05686-020',
    launchDate: '01/05/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'audi',
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "CARAIGÁ VW MORUMBI",
        "CARAIGÁ AUDI MORUMBI",
    ],
    
    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: mainLogoWhite,

    banner01: banner01,
    banner02: banner03,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen e Audi</span> direto das concessionárias <span style="font-weight: bold;">Caraigá</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            'A história da Caraigá começa em 1 de outubro de 1965, sob a liderança de Carlos Roberto Franco de Mattos. O pioneirismo foi um dos pilares que consolidaram o crescimento da marca e fortaleceu sua atuação sobre São Paulo, destaque de atendimento e vendas de Volkswagen desde 1965, se tornou em 1994 a primeira concessionária Audi em território nacional. Agora em 2022 o grupo Caraigá mais uma vez sai na frente e apresenta a vocês nossos clientes, amigos e parceiros duas novidades. Inauguração da 1ª concessionária Volkswagen brasileira com o novo padrão da marca e também 1ª concessionária Audi Progressive Retail mundo! Inovação e foco na sua satisfação fazer parte do nosso DNA, estamos sempre investindo em novas tecnologias e criando relacionamentos com os nossos clientes, amigos e parceiros. Obrigado por fazer parte da nossa história!'
        ],
        link: 'https://caraiga.com.br/institucional',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://instagram.com/grupocaraiga?igshid=MjAxZDBhZDhlNA==',
        Facebook: 'https://www.facebook.com/grupocaraiga?mibextid=LQQJ4d',
        LinkedIn: '',
        Youtube: 'https://www.youtube.com/@caraigacarros',
        Twitter: '',
    },

    footerContent: [],
}